/**
 * Copies the specified text to the user's clipboard
 * @param  {String} text The text to be copied
 * @return {void}
 */
export function copyToClipboard(text) {
    var dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
}

/**
 * Adds the specified query args to the end of the URL
 * @param  {String} url  The URL to modify
 * @param  {Object} args Object of query args in key:value pairs
 * @return {String}      The URL with query args added
 */
export function addQueryArgs(url, args = {}) {
    const a = document.createElement('a');
    a.href = url;
    const params = Object.entries(args).map(
        ([k, v]) => encodeURIComponent(k) + '=' + encodeURIComponent(v)
    );
    return url + (a.search.length > 0 ? '&' : '?') + params.join('&');
}

/**
 * Parses the specified URL and returns any query args as key:value pairs
 * @param  {String} url The URL to pargse
 * @return {Mixed}      The query args in key:value pairs or false if no args
 */
export function getQueryArgs(url) {
    const a = document.createElement('a');
    a.href = url;

    let parts = a.search.replace(/^\?/, '');
    if (parts) {
        parts = parts.split('&');
        parts = parts.map(p => p.split('='));

        let args = {};
        for (let i = 0, l = parts.length; i < l; i++) {
            const arg = parts[i];
            const key = decodeURIComponent(arg[0].replace(/\+/g, '%20'));
            const val = decodeURIComponent(arg[1].replace(/\+/g, '%20'));
            args[key] = val;
        }

        return args;
    }
    return false;
}
